var map = {
	"./ai-videos-the-future-of-content-creation-marketing": [
		8163,
		163
	],
	"./ai-videos-the-future-of-content-creation-marketing.tsx": [
		8163,
		163
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 4021;
module.exports = webpackAsyncContext;